<script>
import { preventDefault } from 'svelte/legacy';
import { lockState } from "@app/store/lockStore.svelte.js";
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import {
    styleState
} from '@app/store/styleStore.svelte.js';
import {
    authState
} from '@app/store/authStore.svelte.js';
import {
    fade
} from 'svelte/transition';
import {
    saveAs
} from 'file-saver';
import Swal from 'sweetalert2'
import { SWAL_BASE, SWAL_CLASSES } from '@app/lib/swalClasses.js';
import throttle from 'just-throttle';
import { activateSubscription } from "@app/lib/activateSubscription.js";
import * as m from "@app/paraglide/messages.js";
/* Firebase */
/* CC LIB */
import encode from "@cclib/functions/encode.js";
import defaults from "@cclib/lib/defaults.js";
import encodings from "@cclib/dict/encodings.js";
import formats from "@cclib/lib/formats.js";
import frameRates from "@cclib/dict/frameRates.js";
import tcLib from '@cclib/lib/timecode.js';
import _Event from "@cclib/classes/event.js";
import offset from "@cclib/functions/events/tcOffset.js";
import tcMultiply from "@cclib/functions/special/tcMultiply.js";
import orderByTime from "@cclib/functions/eventGroups/orderByTime.js";
import removeHtmlEntities from "@cclib/functions/eventGroups/removeHtmlEntities.js";
import replaceTrialText from "@cclib/functions/eventGroups/replaceTrialText.js";
import wrapStyledTextWithSpan from '@cclib/functions/quill/wrapStyledTextWithSpan.js'; 

const TRACK_LETTERS = ["A", "B", "C", "D"];
const ALL_TRACK_OPTIONS = ["none", ...TRACK_LETTERS];

let eventGroup = $state(getSelectedEventGroup(["subtitle", "translation", "audio description", "audio dubbing", "transcription"])),
    trgExt = $state("csv"),
    trgProfile = $state("As-Broadcast Dialogue List CSV"),
    trgFrameRate = $state(projectState.frameRate),
    trgDropFrame = $state(projectState.dropFrame ? "true" : "false"),
    dropFrameConvert = $state(false),
    tcOffset = $state(tcLib.secToTc(projectState.incode, projectState.frameRate, projectState.dropFrame) || "00:00:00:00"),
    tcOffsetType = $state("add"),
    tcMultiplier = $state(1),
    showOptions = $state(false),
    fileEncoding = $state(defaults.encoding),
    fns = $state('include'),
    exportTracks = $state([...ALL_TRACK_OPTIONS]),
    ignoreAll = false;

/* Filter events based on the selected export tracks. All events export when every track is selected (default). */
function filterEventsByTrack(events, selectedTracks) {
    if (
        selectedTracks.length === 0 ||
        ALL_TRACK_OPTIONS.every((option) => selectedTracks.includes(option))
    ) {
        return events;
    }

    return events.filter((event) => {
        const eventTrack = TRACK_LETTERS.includes(event.track)
            ? event.track
            : "none";
        return selectedTracks.includes(eventTrack);
    });
}

if (authState.status === "in_trial"){
    showTrialWarning();
}

function showTrialWarning(){
    Swal.fire({
        ...SWAL_BASE,
        titleText: m.dialogue_list_export_trial_title(),
        text : m.dialogue_list_export_trial_text(),
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: m.dialogue_list_export_trial_activate(),
        denyButtonText: m.dialogue_list_export_trial_continue(),
        allowOutsideClick : false,
        allowEscapeKey : false,
        customClass: SWAL_CLASSES.trial,
    }).then((result) => {
        if (result.isConfirmed) {
            activateSubscription();
        }
    }).catch(err =>{
        console.log(err);
        console.log(err.message)
    });
}

function getSelectedEventGroup(validTypes) {
    let evGroup = eventGroupState[projectState.selected];
    if (evGroup){
        if (validTypes.indexOf(evGroup.type) > -1) {
            return evGroup.id;
        } else {
            return false;
        }
    } else {
        return false;
    }    
}

function validateTc(e) {
    tcOffset = tcLib.tcValidate(e.target.value, parseFloat(trgFrameRate), trgDropFrame === "true" ? true : false);
}

function updateProfile() {
    if (trgExt === "csv"){
        trgProfile = "As-Broadcast Dialogue List CSV"
    } else {
        trgProfile = "As-Broadcast Dialogue List Word"
    }

    trgFrameRate = projectState.frameRate;
    trgDropFrame = projectState.dropFrame ? "true" : "false";
}

async function cancelExport(eventGroupId, eventId) {
    toast.push(m.dialogue_list_export_aborted_toast(), {
        classes: ["toast-warning"]
    });    projectState.selected = eventGroupId;
    eventGroupState[projectState.selected].selected = [eventId];
    setTimeout(() =>{
        const selectedIndex = eventGroupState[projectState.selected].selected[0];
        
        // Dispatch custom event to scroll to the selected event
        window.dispatchEvent(new CustomEvent('scrollToVirtualListItem', {
            detail: { index: selectedIndex }
        }));

        if (lockState.video && player){
            player.currentTime = eventGroupState[projectState.selected].events[selectedIndex].start;
        }
    }, 250);                 
    
    hideModal();
}

function alertUser(msg) {
    let response = Swal.fire({
        ...SWAL_BASE,
        titleText: m.dialogue_list_export_precheck_title(),
        text : msg,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: m.dialogue_list_export_precheck_abort(),
        denyButtonText: m.dialogue_list_export_precheck_ignore(),
        cancelButtonText: m.dialogue_list_export_precheck_ignore_all(),
        allowOutsideClick : false,
        allowEscapeKey : false,
        customClass: SWAL_CLASSES.precheck,
    }).then((result) => {
        if (result.isConfirmed) {
            return true;
        } else if (result.isDenied) {
            return false;
        } else if (result.isDismissed){
            ignoreAll = true;
            return false;
        }
    });

    return response;
}

function alertUserBoolean(msg) {
    let response = Swal.fire({
        ...SWAL_BASE,
        titleText: m.dialogue_list_export_precheck_title(),
        text : msg,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: m.dialogue_list_export_precheck_yes(),
        denyButtonText: m.dialogue_list_export_precheck_no(),
        allowOutsideClick : false,
        allowEscapeKey : false,
        customClass: SWAL_CLASSES.precheck,
    }).then((result) => {
        if (result.isConfirmed) {
            return true;
        } else {
            return false;
        }
    });

    return response;
}

async function preExportCheck(events) {    
    for (let i = 0; i < events.length; i++) {
        if (!ignoreAll) {
            if (events[i].text) {
                if (isNaN(events[i].start)) {
                    if (await alertUser(m.dialogue_list_export_event_missing_start({ index: i + 1 }))) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (isNaN(events[i].end)) {
                    if (await alertUser(m.dialogue_list_export_event_missing_end({ index: i + 1 }))) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (events[i].start === events[i].end) {
                    if (await alertUser(m.dialogue_list_export_event_same_time({ index: i + 1 }))) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (events[i].start > events[i].end) {
                    if (await alertUser(m.dialogue_list_export_event_start_after_end({ index: i + 1 }))) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (i > 0 && events[i].start < events[i - 1].end) {
                    /* Adding check in case overlap is less than a frame */
                    if (events[i - 1].end-events[i].start < 1/projectState.frameRate){
                        events[i].start = events[i - 1].end;
                    } else if (await alertUser(m.dialogue_list_export_event_overlap({ index: i + 1 }))) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                }
            } else {
                if (await alertUser(m.dialogue_list_export_event_missing_text({ index: i + 1 }))) {
                    return {
                        err: true,
                        eventId: i
                    }
                };
            }
        }
        
    }

    return {
        err: false
    }
}

async function exportDialogueList() {
    toast.push(m.dialogue_list_export_toast_start(), {
        classes: ["toast-info"]
    });

    try {
        let options,
            output,
            defaultEncoding = formats.defaultEncodingMap[formats.profileMapping[trgProfile].name],
            eventGroupIndex,
            fileName,
            fileBlob,
            copyOfEventGroup;

            trgFrameRate = parseFloat(trgFrameRate);
            if ([23.976, 24,25,30,50,60].indexOf(trgFrameRate) > -1){
                trgDropFrame = false;
            } else {
                trgDropFrame = trgDropFrame === "true" ? true : false;
            }

        
        eventGroupIndex = eventGroupState.findIndex(group => {
            return group.id === eventGroup;
        });



        fileName = eventGroupState[eventGroupIndex].name + "." + trgExt;
        copyOfEventGroup = JSON.parse(JSON.stringify(eventGroupState[eventGroupIndex]));

        /* FS Filtering START */
        if (fns === "exclude"){
            copyOfEventGroup.events = copyOfEventGroup.events.filter(event =>{
                return !event.forced
            });
        } else if (fns === "only"){
            copyOfEventGroup.events = copyOfEventGroup.events.filter(event =>{
                return event.forced
            });
        }
        /* FS Filtering END */

        /* Track Filtering START */
        copyOfEventGroup.events = filterEventsByTrack(copyOfEventGroup.events, exportTracks);
        /* Track Filtering END */

        copyOfEventGroup = orderByTime(copyOfEventGroup);
        copyOfEventGroup = removeHtmlEntities(copyOfEventGroup);
        let preCheckResult = await preExportCheck(copyOfEventGroup.events);
        if (preCheckResult.err) {
            cancelExport(eventGroupIndex, preCheckResult.eventId)
        } else {
            /* tcOffset */
            if (tcOffset && tcOffset !== "00:00:00:00") {
                copyOfEventGroup.events.forEach((event, index, events) => {
                    events[index] = offset(event, tcLib.tcToSec(tcOffset, trgFrameRate, trgDropFrame), tcOffsetType);
                });
            }

            /* Frame Rate Convert */
            if (dropFrameConvert) {
                copyOfEventGroup = dropFrameConvert(eventGroup, {
                    frameRate: trgFrameRate,
                    dropFrame: trgDropFrame
                });
            }

            if (tcMultiplier && tcMultiplier != 0 && tcMultiplier != 1) {
                copyOfEventGroup = tcMultiply(copyOfEventGroup, tcMultiplier);
            }

            options = new defaults.options({
                profile: formats.profileMapping[trgProfile].name,
                formatOptions: formats.profileMapping[trgProfile].options.encode,
                frameRate: trgFrameRate,
                dropFrame: trgDropFrame,
                target_profile : formats.profileMapping[trgProfile].name,
                source_profile : 'closedCaptionProject',
                window: {
                    width: styleState.width,
                    height: styleState.height,
                    xPadding: styleState.xPadding,
                    yPadding: styleState.yPadding
                }
            });

            if (authState.status === "in_trial"){
                copyOfEventGroup = replaceTrialText(copyOfEventGroup);
            }

            copyOfEventGroup.events.forEach((event, index, events) =>{
                events[index].text = wrapStyledTextWithSpan(event.text);
            });

            output = await encode(copyOfEventGroup, options);

            if (defaultEncoding === "buffer"){
                fileBlob = output;
            } else if (defaultEncoding.toLowerCase() === "hex") {
                let byteArray = new Uint8Array(output.match(/.{2}/g).map(e => parseInt(e, 16)));
                fileBlob = new Blob([byteArray], {
                    type: "application/octet-stream"
                });
            } else if (defaultEncoding.toLowerCase() === "utf-16le") {
                fileBlob = new Blob([output], {
                    type: "text/plain;charset=utf-16le"
                });
            } else {
                fileBlob = new Blob([output], {
                    type: "text/plain;charset=" + fileEncoding
                });
            }

            saveAs(fileBlob, fileName, {
                autoBom: true
            });

            toast.push(m.dialogue_list_export_complete_toast(), {
                classes: ["toast-success"]
            });

            localStorage.setItem("cc-subtitle-export-defaults", JSON.stringify({
                trgExt : trgExt,
                trgProfile : trgProfile,
                tcOffset : tcOffset,
                tcOffsetType : tcOffsetType
            }));

            hideModal();
        }
    } catch (e) {
        console.log(e, e.message);
        toast.push(m.dialogue_list_export_failed_toast({ error: e.message }), {
            classes: ["toast-danger"]
        });
    }
}
</script>

<div transition:fade={{duration: 100}} 
    class="modal {modalState.selected === 'dialogueListExport' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="dialogueExportTitle"
    aria-describedby="dialogueExportDesc"
    tabindex="-1" 
    id="dialogueListExportModal">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="dialogueExportTitle">{m.dialogue_list_export_title()}</h4>
                <button type="button" class="btn-close" aria-label={m.dialogue_list_export_close_label()} onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <p id="dialogueExportDesc" class="small text-muted">
                    <i class="bi bi-lightning-fill" aria-hidden="true"></i> 
                    {m.dialogue_list_export_powered_by()}
                </p>
                <form id="dialogueExportForm" onsubmit={preventDefault(exportDialogueList)} aria-label={m.dialogue_list_export_form_label()}>
                    <div class="mb-3">
                        <label class="form-label" for="eventGroupSelect">{m.dialogue_list_export_event_group_label()}</label>
                        <select id="eventGroupSelect" class="form-select" bind:value={eventGroup} aria-required="true">
                            {#each eventGroupState as eventGroupOption (eventGroupOption.id)}
                                <option value={eventGroupOption.id}>{eventGroupOption.name}</option>
                            {/each}
                        </select>
                    </div>
                    
                    <div class="row">
                        <div class="mb-3 col">
                            <label class="form-label" for="formatSelect">{m.dialogue_list_export_format_label()}</label>
                            <select id="formatSelect" class="form-select" bind:value={trgExt} onchange={updateProfile} aria-required="true">
                                <option>csv</option>
                                <option>docx</option>
                            </select>
                        </div>
                    </div>

                    <button 
                        type="button" 
                        id="toggleOptionsBtn"
                        class="btn btn-outline-warning mb-2 dropdown-toggle" 
                        onclick={()=> {showOptions = !showOptions}}
                        aria-expanded={showOptions}
                        aria-controls="advancedOptions">
                        {m.dialogue_list_export_more_options()}
                    </button>

                    {#if showOptions}
                    <div id="advancedOptions" class="p-3 bg-secondary shadow rounded" aria-label={m.dialogue_list_export_advanced_options_label()}>
                        <!-- Advanced Options -->
                        <p class="lead text-warning">{m.dialogue_list_export_general_options()}</p>
                        <!-- Frame Rate + Drop Frame -->
                        {#if formats.profileMapping[trgProfile].timecode !== 'ms'}
                        <div class="row">
                            <div class="mb-3 col-8">
                                <label class="form-label" for="TrgFrameRateSelect">{m.dialogue_list_export_frame_rate()}</label>
                                <select id="TrgFrameRateSelect" class="form-select" bind:value={trgFrameRate}>
                                    {#each frameRates.frameRates as frameRate (frameRate)}
                                    <option selected={frameRate == trgFrameRate}>{frameRate}</option>
                                    {/each}
                                </select>
                            </div>
                            {#if parseFloat(trgFrameRate) === 29.97 || parseFloat(trgFrameRate) === 59.94}
                            <div class="mb-3 col-4">
                                <label class="form-label" for="trgDropFrameSelect">{m.dialogue_list_export_drop_frame()}</label>
                                <select id="trgDropFrameSelect" class="form-select" bind:value={trgDropFrame}>
                                    <option value="true">{m.dialogue_list_export_drop_frame_true()}</option>
                                    <option value="false">{m.dialogue_list_export_drop_frame_false()}</option>
                                </select>
                            </div>
                            {/if}
                        </div>
                        {/if}
                        <!-- Timecode Offset -->
                        <div class="row">
                            <div class="mb-3 col-8">
                                <label class="form-label" for="tcOffset">{m.dialogue_list_export_tc_offset()}</label>
                                <input type="text" class="form-control" bind:value={tcOffset} onblur={validateTc} onfocus={(e)=>{e.target.select()}}/>
                            </div>

                            <div class="mb-3 col-4">
                                <label class="form-label" for="tcOffsetType">{m.dialogue_list_export_offset_type()}</label>
                                <select class="form-select" bind:value={tcOffsetType}>
                                    <option value="add">{m.dialogue_list_export_offset_add()}</option>
                                    <option value="subtract">{m.dialogue_list_export_offset_subtract()}</option>
                                </select>
                            </div>
                        </div>
                        <!-- Timecode Multiplier -->
                        <div class="row">
                            <div class="mb-3 col-8">
                                <label class="form-label" for="tcMultiplier">{m.dialogue_list_export_tc_multiplier()}</label>
                                <input type="number" class="form-control" bind:value={tcMultiplier} onfocus={(e)=>{e.target.select()}}/>
                            </div>
                        </div>
                        <!-- File Encoding -->
                        <div class="mb-3">
                            <label class="form-label" for="TrgFileEncoding">{m.dialogue_list_export_file_encoding()}</label>
                            <select class="form-select" bind:value={fileEncoding}>
                                {#each encodings as encodingOption (encodingOption)}
                                <option>{encodingOption}</option>
                                {/each}
                            </select>
                        </div>
                        <!-- Drop Frame Convert -->
                        <div class="mb-3">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="dropFrameConvert" bind:checked={dropFrameConvert} />
                                <label class="form-check-label" for="dropFrameConvert">
                                    {m.dialogue_list_export_drop_frame_convert()}
                                    <i class="bi bi-info-circle" title={m.dialogue_list_export_drop_frame_convert_help()}></i>
                                </label>
                            </div>
                        </div>
                        <div class="mb-3">
                            <p class="text-warning mb-1">{m.dialogue_list_export_forced_subtitles()}</p>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="fnsOption" id="includeFns" bind:group={fns} value="include">
                                <label class="form-check-label" for="includeFns">{m.dialogue_list_export_include_fs()}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="fnsOption" id="excludeFns" bind:group={fns} value="exclude">
                                <label class="form-check-label" for="excludeFns">{m.dialogue_list_export_exclude_fs()}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="fnsOption" id="onlyFns" bind:group={fns} value="only">
                                <label class="form-check-label" for="onlyFns">{m.dialogue_list_export_fs_only()}</label>
                            </div>
                        </div>
                        <!-- Export Tracks -->
                        <div class="mb-3">
                            <label class="form-label text-warning mb-1" for="exportTracksSelect">
                                {m.export_tracks()}
                                <i class="bi bi-info-circle" title={m.export_tracks_help()}></i>
                            </label>
                            <select id="exportTracksSelect" class="form-select" multiple size="5" bind:value={exportTracks}>
                                <option value="none">{m.event_track_none()}</option>
                                {#each TRACK_LETTERS as letter (letter)}
                                    <option value={letter}>{m.multiview_track()} {letter}</option>
                                {/each}
                            </select>
                        </div>
                        {#if formats.profileMapping[trgProfile].options && formats.profileMapping[trgProfile].options.encode.length > 0}
                        <div class="row border-top border-secondary">
                            <p class="col-12 lead text-warning pt-2">{m.dialogue_list_export_encoding_options()}</p>
                            {#each formats.profileMapping[trgProfile].options.encode as encodeOption (encodeOption.name)}
                            <div class="mb-3 col-6">
                                <label class="form-label" for="decodingOption">{encodeOption.name}</label>
                                {#if encodeOption.type==='textarea'}
                                <textarea class="form-control" rows="3" bind:value={encodeOption.selected}></textarea>
                                {:else if encodeOption.type==='text-input'}
                                <input class="form-control" type="text" bind:value={encodeOption.selected} />
                                {:else if encodeOption.type==='number-input'}
                                <input class="form-control" type="number" bind:value={encodeOption.selected} />
                                {:else}
                                <select class="form-select" bind:value={encodeOption.selected}>
                                    {#each encodeOption.values as valueOption (valueOption)}
                                    <option>{valueOption}</option>
                                    {/each}
                                </select>
                                {/if}
                            </div>
                            {/each}
                        </div>
                        {/if}
                    </div>
                    {/if}
                </form>
            </div>
            <div class="modal-footer">
                <button 
                    id="exportBtn"
                    class="btn btn-primary" 
                    type="button" 
                    disabled={!eventGroup} 
                    onclick={exportDialogueList}
                    aria-disabled={!eventGroup}>
                    {m.dialogue_list_export_export_button()}
                </button>
            </div>
        </div>
    </div>
</div>
